import styled from "styled-components";
import { palette } from "styled-theme";
import ContentWrapper from "../../components/contentWrapper";

const Wrapper = styled(ContentWrapper).attrs(() => ({
  as: "main"
}))`
  display: flex;
  flex-direction: column;
  text-align: center;
  
    .page-heading { 
      max-width: 500px;
      margin: 20px auto;
      line-height: 44px;
    }

  p:not(:last-child)  {
    padding-bottom: 20px;
  }

  a {
    color: ${palette("color", 14)};
    text-decoration: none;
  }
`;

export default Wrapper;
